<template>
    <header>
        <div class="container">
            <div class="logo">
                <router-link to="/index">
                    <img src="../image/CCAPPLOGO.png" alt="logo" style="width:150px;">
                </router-link>
            </div>
            <div class="navBar">
                <div class="language">
                    <div class="choose" ><i class="cn" @click="btn()">中文</i><i @click="btn2()">English</i></div>
                </div>
                <ul id="headerNav">
                    <li class="on">
                        <router-link to="/index"> {{$t('header.home')}} </router-link>
                    </li>
                    <li>
                        <router-link to="/aboutUs"> {{$t('header.aboutUs')}} </router-link>
                        <div class="hoverNav" style="width:160px;">
                            <div class="hoverList">
                                <router-link to="/aboutUs">{{$t('ccapp.tit')}}</router-link>
                            </div>
                            <div class="hoverList">
                                <router-link to="/frame">{{$t('ccapp.tit1')}}</router-link>
                            </div>
                            <div class="hoverList">
                                <router-link to="/job">{{$t('ccapp.tit5')}}</router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <router-link to="/partner"> {{$t('header.partners')}} </router-link>
                        <div class="hoverNav">
                            <div class="hoverList">
                                <router-link to="/partner">{{$t('partner.tit')}}</router-link>
                            </div>
                            <div class="hoverList">
                                <router-link to="/partners">{{$t('partner.tit1')}}</router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <router-link to="/report"> {{$t('header.reports')}} </router-link>
                    </li>
                    <li>
                        <router-link to="/resources/77">{{$t('header.resources')}}</router-link>
                    </li>
                    <li>
                        
                        <router-link :to="{name:'NewsPage',params:{id:69, category:1}}"> {{$t('header.newsArchive')}} </router-link>
                        <div class="hoverNav" style="width:160px;">
                            <div class="hoverList">
                                <router-link :to="{name:'NewsPage',params:{id:69, category:1}}">{{$t('news.Release')}}</router-link>
                            </div>
                            <div class="hoverList">
                                <router-link :to="{name:'NewsPage',params:{id:70, category:2}}">{{$t('news.activity')}}</router-link>
                            </div>
                            <div class="hoverList">
                                <router-link :to="{name:'NewsPage',params:{id:71, category:3}}">{{$t('news.Past period')}}</router-link>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: "MyHeader",
        props: {
            index: String
        },
        mounted() {
            this.headerNavClick();
        },
        methods: {
            headerNavClick() {
                if (!this.index) {
                    this.index = 0;
                }
                $('#headerNav li').eq(Number(this.index)).addClass('on').siblings().removeClass('on');
            },
            btn() {
               
                    this.$i18n.locale = 'zh_CN';
                    localStorage.setItem("locale",'zh_CN');
               
                window.location.reload(); 
            },
             btn2() {
               
                    this.$i18n.locale = 'en_US';
                    localStorage.setItem("locale",'en_US');
                
                window.location.reload(); 
            }
        }
    }
</script>

<style lang="scss" scoped>
    header {
        width: 100%;

        .container {
            overflow: visible;
            height: 79px;

            .logo {
                float: left;
                margin-top: 0px;
            }

            .navBar {
                float: right;
                height: 100%;

                .language {
                    text-align: right;
                    margin-top: 16px;
                    height: 16px;

                    .choose {
                        height: 16px;
                        line-height: 16px;

                        i {
                            display: inline-block;
                            line-height: 16px;
                            font-size: 12px;
                            height: 16px;
                            color: #2DB0EC;
                            cursor: pointer;
                        }
                    }

                    .cn {
                        &:after {
                            cursor: auto;
                            content: ' 丨 ';
                        }
                    }
                }

                ul {
                    margin-top: 12px;
                    height: 35px;
                    width: 100%;
                    display: block;

                    li {
                        cursor: pointer;
                        float: left;
                        margin-left: 44px;
                        color: #5E5E5E;
                        font-size: 16px;
                        height: 20px;
                        line-height: 20px;
                        padding-bottom: 12px;
                        position: relative;

                        &:hover {
                            .hoverNav {
                                height: 120px;
                            }
                        }

                        .hoverNav {
                            z-index: 10;
                            position: absolute;
                            top: 35px;
                            right: 0;
                            width: 130px;
                            transform: translateX(25%);
                            transition: all 0.8s;
                            height: 0;
                            overflow: hidden;

                            .hoverList {
                                a {
                                    display: block;
                                    color: #5E5E5E;
                                    background: #ffffff;
                                    font-size: 15px;
                                    height: 40px;
                                    line-height: 40px;
                                    font-weight: 400;
                                    text-align: center;

                                    &:hover {
                                        background: #32B87B;
                                        color: #FFFFFF;
                                    }
                                }

                                .on {
                                    background: #32B87B;
                                    color: #FFFFFF;
                                }
                            }

                        }

                        a {
                            color: #5E5E5E;
                            display: block;
                        }

                        &:last-child {
                            margin-right: 0;
                        }
                    }

                    .on {
                        font-weight: bold;
                        color: #13AE67;
                        border-bottom: 3px #13AE67 solid;
                    }
                }
            }
        }
    }
</style>